export default "__VITE_ASSET__BPC$vuv8__"